import React, { useCallback, useEffect, useState } from "react";
import classes from "./MovingBetweenCashRegister.module.css";
import DefaultSelect from "../../components/form/DefaultSelect";
import { getCashRegisters } from "../../lib/OptionListApi";
import DefaultInput from "../../components/form/DefaultInput";
import { Button } from "antd";
import api from "../../utils/axios";
import { toast } from "react-toastify";
import useLang from "../../hooks/useLang";

const MovingBetweenCashRegister = () => {
	const [cashRegisterInId, setCashRegisterInId] = useState(null);
	const [cashRegisterOutId, setCashRegisterOutId] = useState(null);
	const [cashRegisterDropDown, setCashRegisterDropDown] = useState<any>([]);
	const [amount, setAmount] = useState(0);

	const fetchCashRegisters = useCallback(async () => {
		const cashRegisters = await getCashRegisters();
		if (cashRegisters?.length > 0) {
			const formattedCashRegisters = cashRegisters?.map((item: any) => ({
				value: item.id,
				label: item.description,
			}));
			setCashRegisterDropDown(formattedCashRegisters);
		}
	}, []);

	useEffect(() => {
		fetchCashRegisters();
	}, []);

	const resetForm = () => {
		setCashRegisterInId(null);
		setCashRegisterOutId(null);
		setAmount(0);
	};

	const validateInput = () => {
		if (!cashRegisterInId) {
			toast.error(strings?.errors.cashRegisterInId);
			return false;
		}
		if (!cashRegisterOutId) {
			toast.error(strings?.errors.cashRegisterOutId);
			return false;
		}
		if (!amount || amount <= 0) {
			toast.error(strings?.errors.amount);
			return false;
		}
		if (cashRegisterInId === cashRegisterOutId) {
			toast.error(strings?.errors.sameCashRegister);
			return false;
		}
		return true;
	};

	const handleSubmit = async () => {
		if (validateInput()) {
			try {
				const response = await api.post(
					"Finance/CashRegisterAmount",
					null,
					{ params: { id: cashRegisterOutId } }
				);
				const cashRegisterAmount = response.data;

				if (cashRegisterAmount < amount) {
					toast.error(strings?.insufficientFunds);
					return false;
				}
			} catch (error: any) {
				console.error(error.response?.data || error.message);
				toast.error(strings?.fundsVerificationError);
				return false;
			}

			const cashRegisterMovementData = {
				CashRegisterInId: cashRegisterInId,
				CashRegisterOutId: cashRegisterOutId,
				Amount: amount,
			};

			try {
				const response = await api.post(
					"Finance/CashRegisterMovement",
					cashRegisterMovementData
				);
				resetForm();
				toast.success(strings?.transferSuccesful);
			} catch (error: any) {
				console.error(error.response.data);
				toast.error(strings?.transferError);
			}
		} else {
			toast.error(strings?.fillFields);
		}
	};

	const { strings } = useLang("movingBetweenscashregister");

	return (
		<div className={classes.mainContainer}>
			<div className={classes.heroContainer}>
				<p className={classes.heroTitle}>{strings?.title}</p>
				<div className={classes.inputsContainer}>
					<DefaultSelect
						label={strings?.cashRegisterFrom}
						placeholder={strings?.cashRegisterFrom}
						width={355}
						options={cashRegisterDropDown}
						onChange={(value) => setCashRegisterOutId(value)}
						allowClear={true}
						onClear={() => setCashRegisterOutId(null)}
						flexDirection="col"
						alignCenter="start"
						className={classes.secondInput}
					/>
					<DefaultSelect
						label={strings?.cashRegisterTo}
						placeholder={strings?.cashRegisterTo}
						width={355}
						options={cashRegisterDropDown}
						onChange={(value) => setCashRegisterInId(value)}
						allowClear={true}
						onClear={() => setCashRegisterInId(null)}
						flexDirection="col"
						alignCenter="start"
						className={classes.secondInput}
					/>
					<DefaultInput
						label={strings?.amount}
						placeholder={strings?.amount}
						className={classes.secondInput}
						onChange={(e) => setAmount(e.target.value)}
					/>
				</div>
				<div className={classes.buttonContainer}>
					<Button className={classes.button} onClick={handleSubmit}>
						{strings?.submit}
					</Button>
				</div>
			</div>
		</div>
	);
};

export default MovingBetweenCashRegister;
